export default __webpack_public_path__ + "static/empty-list-bd7b5878597c6d66ef720b0dbe680d95.png";